// Central editable business config — update phone, address, links here.
export const SITE = {
  name: "Blue City Taxi",
  url: "https://www.bluecitytaxi.in",
  tagline: "Taxi Service in Jodhpur & Across Rajasthan",
  phoneDisplay: "094602 05326",
  phoneTel: "+919460205326",
  whatsapp: "919460205326",
  email: "anilcharan63@gmail.com",
  tagline2: "Jodhpur's Trusted Travel Partner",
  address1: "Near Jhalamand, Navdurga Colony,",
  address2: "Jhalamand, Jodhpur, Rajasthan 342016",
  city: "Jodhpur",
  state: "Rajasthan",
  // Owner-provided Google Business Profile / directions link
  googleProfile:
    "https://www.google.com/maps/dir/23.0490112,72.5549056/Blue+City+Taxi,+near+Jhalamand,+Navdurga+Colony,+Jhalamand,+Jodhpur,+Rajasthan+342016/@24.636014,71.5229603,8z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x39418b114471393f:0x8edf62407a4851fc!2m2!1d73.0380422!2d26.2345323?entry=ttu&g_ep=EgoyMDI2MTAwNS4wIKXMDSoASAFQAw%3D%3D",
  mapEmbed:
    "https://www.google.com/maps?q=Blue+City+Taxi,+Jhalamand,+Jodhpur,+Rajasthan+342016&output=embed",
  defaultWaMsg:
    "Hello Vikash ji, I want to book a taxi. Please share availability and fare.",
};

export const waLink = (msg = SITE.defaultWaMsg) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg)}`;

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "My Fleet", to: "/fleet" },
  { label: "One Way", to: "/one-way-taxi" },
  { label: "All Rajasthan", to: "/all-rajasthan-taxi" },
  { label: "Tour Packages", to: "/tour-packages" },
  { label: "Gallery", to: "/gallery" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  heroJodhpur:
    "https://images.unsplash.com/photo-1602643454724-21d5a40722db?crop=entropy&cs=srgb&fm=jpg&q=85",
  mehrangarh:
    "https://images.unsplash.com/photo-1718923085467-b0bee953eb09?crop=entropy&cs=srgb&fm=jpg&q=85",
  jaipur:
    "https://images.unsplash.com/photo-1615836245337-f5b9b2303f10?crop=entropy&cs=srgb&fm=jpg&q=85",
  udaipur:
    "https://images.unsplash.com/photo-1589901164570-f9de6556e1c1?crop=entropy&cs=srgb&fm=jpg&q=85",
  jaisalmer:
    "https://images.unsplash.com/photo-1521182481757-0694c584d00a?crop=entropy&cs=srgb&fm=jpg&q=85",
  camels:
    "https://images.unsplash.com/photo-1697464026024-046547ebd141?crop=entropy&cs=srgb&fm=jpg&q=85",
  sedan:
    "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?crop=entropy&cs=srgb&fm=jpg&q=85",
  suv: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?crop=entropy&cs=srgb&fm=jpg&q=85",
  luxury:
    "https://images.unsplash.com/photo-1563720223185-11003d516935?crop=entropy&cs=srgb&fm=jpg&q=85",
  tempo:
    "https://images.unsplash.com/photo-1570125909232-eb263c188f7e?crop=entropy&cs=srgb&fm=jpg&q=85",
  airport:
    "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?crop=entropy&cs=srgb&fm=jpg&q=85",
  highway:
    "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?crop=entropy&cs=srgb&fm=jpg&q=85",
  pushkar:
    "https://images.unsplash.com/photo-1589901164570-f9de6556e1c1?crop=entropy&cs=srgb&fm=jpg&q=85",
  mountAbu:
    "https://images.unsplash.com/photo-1506744038136-46273834b3fb?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const socials = {
  whatsapp: waLink(),
  instagram: "#",
  facebook: "#",
  youtube: "#",
  tripadvisor: "#",
  google: SITE.googleProfile,
};

export const img = (url, w = 1200) =>
  `${url}&w=${w}&auto=format&fit=crop`;
